import { render, staticRenderFns } from "./FullSpinner.vue?vue&type=template&id=0cafdc99&"
import script from "./FullSpinner.vue?vue&type=script&lang=js&"
export * from "./FullSpinner.vue?vue&type=script&lang=js&"
import style0 from "./FullSpinner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports